import {
  Box,
  Stack,
  Text,
  Card,
  HStack,
  Icon,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  useDisclosure,
  Image,
} from "@chakra-ui/react";
import { FaEye } from "react-icons/fa";

/**
 * DocumentCard - Displays a document card with view button and modal
 * @param {string} label - Label for the document
 * @param {string} imageUrl - URL to the document image
 * @returns {JSX.Element}
 */
export const DocumentCard = ({ label, imageUrl }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleViewClick = (e) => {
    e.stopPropagation();
    if (imageUrl && imageUrl.trim()) {
      onOpen();
    }
  };

  return (
    <>
      <Stack width="100%">
        <Card
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          p={3}
          cursor={imageUrl && imageUrl.trim() ? "pointer" : "default"}
          _hover={
            imageUrl && imageUrl.trim()
              ? { boxShadow: "md", borderColor: "blue.400" }
              : {}
          }
          onClick={handleViewClick}
        >
          <HStack justify="space-between" mb={2}>
            <Text fontSize="sm" fontWeight="bold" color="black">
              {label}
            </Text>
            {imageUrl && imageUrl.trim() && (
              <Button
                size="sm"
                variant="ghost"
                leftIcon={<Icon as={FaEye} />}
                onClick={handleViewClick}
              >
                View
              </Button>
            )}
          </HStack>
        </Card>
        {!imageUrl || !imageUrl.trim() ? (
          <Text fontSize="sm" color="gray.600">
            -
          </Text>
        ) : (
          <Text fontSize="xs" color="gray.500">
            Click to view
          </Text>
        )}
      </Stack>

      {/* Image View Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <Box p={6}>
            <Text fontSize="md" fontWeight="bold" mb={4}>
              {label}
            </Text>
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={label}
                maxH="500px"
                maxW="100%"
                objectFit="contain"
                borderRadius="md"
              />
            )}
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DocumentCard;
